'use client'

import React from 'react'
import { AmbientField } from '@/components/member/AmbientField'
import Link from 'next/link'

export default function AppNotFound() {
  return (
    <div className="relative min-h-screen bg-canvas text-fg">
      <AmbientField mood="calm" />
      <div className="relative z-[1] mx-auto flex min-h-screen max-w-lg flex-col justify-center px-6 py-16">
        <p className="text-micro text-fg-muted">404</p>
        <h1 className="mt-3 font-serif text-[clamp(1.75rem,5vw,2.35rem)] font-normal leading-snug">
          Page not found
        </h1>
        <p className="mt-4 text-body-lg text-fg-muted leading-relaxed">
          That path doesn&apos;t exist in this community.
        </p>
        <Link href="/member-home" className="btn-primary mt-10 inline-flex w-fit">
          Back to Home
        </Link>
      </div>
    </div>
  )
}
